module.exports = __webpack_public_path__ + "static/media/pokeapp.37399dea.png";